module.exports = __webpack_public_path__ + "static/media/git-vector.a0ae7853.jpg";